module.exports = __webpack_public_path__ + "static/img/categories9.bff7d8e.png";


//////////////////
// WEBPACK FOOTER
// ./static/recycle/categories9.png
// module id = Gufh
// module chunks = 1